/** The four-point sparkle from the PME brand deck, used as a quiet accent. */
export default function Sparkle({
  size = 16,
  colour = "#df95ef",
  className,
}: {
  size?: number;
  colour?: string;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-10 -10 20 20"
      aria-hidden
      focusable="false"
      className={className}
    >
      <path
        fill={colour}
        d="M0,-10 Q1.2,-1.2 10,0 Q1.2,1.2 0,10 Q-1.2,1.2 -10,0 Q-1.2,-1.2 0,-10Z"
      />
    </svg>
  );
}
